export function Account({ t }) {
    return (
        <></>
    );
}